export const dropdownFieldValid = value => value !== 'Unmapped';

export const textFieldValid = value => value && value !== '';

export const accountNumberIsValid = number => /^\d{4,6}$/g.test(number);

export const templateNameIsValid = name => name && name !== '';

const memberIsValid = member =>
  (member.source === 'Text' && textFieldValid(member.value)) ||
  (member.source !== 'Text' && dropdownFieldValid(member.value));

const fieldIsValid = field => field.members.every(m => memberIsValid(m));

export const validateRuleFields = rule =>
  fieldIsValid(rule.series) &&
  fieldIsValid(rule.company) &&
  fieldIsValid(rule.voucherText) &&
  fieldIsValid(rule.transactionText);

const validateAccount = account =>
  accountNumberIsValid(account.accountNumber) &&
  account.objectMappings.every(m => fieldIsValid(m.field));

const validateRule = rule =>
  validateRuleFields(rule) &&
  validateAccount(rule.credit) &&
  validateAccount(rule.debit);

const rulesAreValid = rules => rules.every(validateRule);

export const eventTypeRulesAreValid = eventTypeRules =>
  eventTypeRules.every(etr => rulesAreValid(etr.rules));

export const validateDefaultFields = defaultFields =>
  fieldIsValid(defaultFields.series) &&
  fieldIsValid(defaultFields.company) &&
  fieldIsValid(defaultFields.voucherText) &&
  fieldIsValid(defaultFields.transactionText);

const areCustomFieldsValid = customFields =>
  customFields.every(
    customField => customField.customFieldId !== '' && customField.name !== ''
  );

export const validateCustomAndDefaultFields = fieldsAndTemplates =>
  areCustomFieldsValid(fieldsAndTemplates.customFields) &&
  validateDefaultFields(fieldsAndTemplates.defaultFields);
